import { useStorage } from '@vueuse/core'
import router from '@/router'

import { add, isAfter } from 'date-fns'

import { HomeBlock, ProductScope } from '@/types/products.search.interfaces'

const initScope: ProductScope[] = [
  {
    rule: 'ai_automation',
    filters: {
      category: '894',
    },
    fromApi: false,
    merchantNeed: true,
    color: 'blue',
  },
  {
    rule: 'increase_average_cart',
    filters: {
      category: '837',
    },
    fromApi: false,
    merchantNeed: true,
    color: 'yellow',
  },
  {
    rule: 'migrate_my_store',
    filters: {
      category: '451',
    },
    fromApi: false,
    merchantNeed: true,
    color: 'purple',
  },
  {
    rule: 'increase_customer_satisfaction',
    filters: {
      category: '838',
    },
    fromApi: false,
    merchantNeed: true,
    color: 'green',
  },
  {
    rule: 'optimize_conversions',
    filters: {
      category: '839',
    },
    fromApi: false,
    merchantNeed: true,
    color: 'blue',
  },
  {
    rule: 'increase_traffic',
    filters: {
      category: '840',
    },
    fromApi: false,
    merchantNeed: true,
    color: 'yellow',
  },
  {
    rule: 'make_browsing_easier',
    filters: {
      category: '841',
    },
    fromApi: false,
    merchantNeed: true,
    color: 'purple',
  },
  {
    rule: 'save_time',
    filters: {
      category: '842',
    },
    fromApi: false,
    merchantNeed: true,
    color: 'green',
  },
]

export default function () {
  const storage = useStorage(`scope`, {
    expiredAt: new Date(),
    scopes: initScope,
  })

  if (isAfter(new Date(), new Date(storage.value.expiredAt))) {
    storage.value.scopes = initScope
    storage.value.expiredAt = add(new Date(), { days: 7 })
  }

  function getScope(scopeRule: string | undefined): ProductScope | undefined {
    const scope = storage.value.scopes.find((scope) => scope.rule === scopeRule)

    if (scope === undefined) {
      router.push({ name: 'home' })
      return
    }

    return scope
  }

  async function saveScopes(blocks: HomeBlock[]) {
    storage.value.scopes = initScope.concat(
      blocks.map(
        (block) =>
          ({
            rule: block.details.rule,
            orderBy: block.sorting.actual,
            label: block.details.label,
            description: block.details.description,
            color: block.details.color,
            filters: block.details.filters,
            showSeeAllButton: block.details.link_label !== '',
            fromApi: true,
          }) as ProductScope,
      ),
    )
  }

  function getScopes(): ProductScope[] {
    return storage.value.scopes
  }

  function getScopeBackgroundColor(scopeRule: string | undefined): string {
    const scope = getScope(scopeRule)
    if (scope?.color === undefined || scope.color === 'highlight') return 'gray'
    return scope.color
  }

  function getScopeLabel(scopeRule: string, t: any): string {
    const scope = getScope(scopeRule)

    if (scope === undefined) return ''

    if (scope.merchantNeed) return t(`merchant_needs.${scopeRule}.title`)

    return scope.label || ''
  }

  return {
    saveScopes,
    getScope,
    getScopes,
    getScopeLabel,
    getScopeBackgroundColor,
  }
}
